module.exports = __webpack_public_path__ + "img/img-2-2mobile.fff34629.png";